<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Ofertas</li>
  </ol>
</div>

<div class="bio-page-header">
  <h4 class="bio-page-title">Ofertas do Cardápio</h4>
  <p class="bio-page-subtitle">Gerencie os produtos em promoção exibidos na sua página Bio</p>
</div>

<!-- Loading -->
<div class="bio-loading" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<!-- Alerta sem bio page -->
<div class="card-no-bio" *ngIf="!carregando && !idBioPagina">
  <div class="card-no-bio-inner">
    <div class="empty-state-icon">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <p>Configure primeiro a página Bio em "Configurações" antes de visualizar ofertas.</p>
    <a routerLink="/admin/bio/configuracoes" class="btn-go-config">
      <i class="fas fa-cog mr-1"></i> Ir para Configurações
    </a>
  </div>
</div>

<!-- Layout com preview -->
<div class="bio-layout" *ngIf="!carregando && idBioPagina">
  <!-- Coluna esquerda: Conteúdo -->
  <div class="form-panel">

    <!-- Card de configurações -->
    <div class="config-card">
      <!-- Toggle Exibir -->
      <div class="config-toggle-row">
        <div class="config-toggle-info">
          <span class="config-toggle-title">Exibir ofertas na Bio</span>
          <span class="config-toggle-subtitle">Seus clientes verão as promoções ativas</span>
        </div>
        <kendo-switch [ngModel]="exibirOfertas"
                      (valueChange)="toggleExibirOfertas()"
                      [onLabel]="''"
                      [offLabel]="''">
        </kendo-switch>
      </div>

      <!-- Modo de exibição -->
      <div *ngIf="exibirOfertas">
        <hr class="config-divider" />
        <div class="config-mode-section">
          <span class="config-mode-title">Modo de exibição</span>
          <div class="mode-cards-grid">
            <div class="mode-card"
                 [class.active]="modoExibicaoOfertas === 'slide'"
                 (click)="alterarModoExibicaoOfertas('slide')">
              <div class="mode-card-icon-wrap">
                <i class="fas fa-images"></i>
              </div>
              <div class="mode-card-text">
                <span class="mode-card-label">Slide</span>
                <span class="mode-card-desc">Carrossel deslizante</span>
              </div>
            </div>
            <div class="mode-card"
                 [class.active]="modoExibicaoOfertas === 'lista'"
                 (click)="alterarModoExibicaoOfertas('lista')">
              <div class="mode-card-icon-wrap">
                <i class="fas fa-list"></i>
              </div>
              <div class="mode-card-text">
                <span class="mode-card-label">Lista</span>
                <span class="mode-card-desc">Itens empilhados</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Secao Ofertas Ativas -->
    <div class="ofertas-section">
      <div class="ofertas-section-header">
        <span class="ofertas-section-title">OFERTAS ATIVAS</span>
        <button class="btn-refresh" (click)="sincronizarOfertas()">
          <i class="fas fa-sync-alt"></i> Atualizar Lista
        </button>
      </div>

      <!-- Estado vazio -->
      <div class="empty-state" *ngIf="ofertas.length === 0">
        <div class="empty-state-icon">
          <i class="fas fa-tags"></i>
        </div>
        <h5 class="empty-state-title">Nenhuma oferta sincronizada</h5>
        <p class="empty-state-text">
          Clique em "Atualizar Lista" para sincronizar a Bio com os produtos
          que estão em promoção no cardápio neste momento.
        </p>
      </div>

      <!-- Lista de ofertas sincronizadas -->
      <div class="produtos-grid" *ngIf="ofertas.length > 0">
        <div class="produto-card" *ngFor="let produto of ofertas">
          <div class="produto-thumb">
            <img *ngIf="produto.urlImagem" [src]="'/images/empresa/' + produto.urlImagem" alt="Produto" />
            <div *ngIf="!produto.urlImagem" class="produto-thumb-placeholder">
              <i class="fas fa-utensils"></i>
            </div>
          </div>
          <div class="produto-info">
            <div class="produto-header">
              <span class="produto-nome">{{produto.titulo}}</span>
              <label class="produto-toggle">
                <span class="produto-toggle-text">Exibir na Link Bio</span>
                <kendo-switch [ngModel]="produto.exibirNaBio"
                              (valueChange)="alterarExibicaoOferta(produto, $event)"
                              [onLabel]="''"
                              [offLabel]="''">
                </kendo-switch>
              </label>
            </div>
            <span class="produto-desc" *ngIf="produto.descricao">
              {{produto.descricao | slice:0:80}}{{produto.descricao?.length > 80 ? '...' : ''}}
            </span>
            <div class="produto-precos">
              <span *ngIf="produto.precoOriginal" class="preco-de">
                R$ {{produto.precoOriginal | number:'1.2-2'}}
              </span>
              <span *ngIf="produto.precoPromocional" class="preco-por">
                R$ {{produto.precoPromocional | number:'1.2-2'}}
              </span>
              <span *ngIf="produto.textoBadge" class="badge-oferta">
                {{produto.textoBadge}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna direita: Preview -->
  <div class="preview-panel">
    <span class="preview-label">Preview</span>

    <!-- Toggle Mobile/Desktop -->
    <div class="preview-mode-toggle">
      <button class="preview-mode-btn"
              [class.active]="modoPreview === 'mobile'"
              (click)="modoPreview = 'mobile'">
        <i class="fas fa-mobile-alt"></i> Mobile
      </button>
      <button class="preview-mode-btn"
              [class.active]="modoPreview === 'desktop'"
              (click)="modoPreview = 'desktop'">
        <i class="fas fa-desktop"></i> Desktop
      </button>
    </div>

    <!-- Frame do celular -->
    <div class="phone-frame" [ngClass]="{'desktop-frame': modoPreview === 'desktop'}">
      <div class="phone-notch" *ngIf="modoPreview === 'mobile'"></div>
      <div class="phone-screen">
        <iframe *ngIf="urlPreview"
                [src]="urlPreview"
                class="preview-iframe"
                frameborder="0"
                scrolling="yes">
        </iframe>
        <div *ngIf="!urlPreview" class="no-preview">
          <i class="fas fa-eye-slash fa-2x text-muted mb-2"></i>
          <p class="text-muted">Configure o slug para visualizar o preview</p>
        </div>
      </div>
      <div class="phone-home-bar" *ngIf="modoPreview === 'mobile'"></div>
    </div>

    <div class="preview-actions" *ngIf="urlPreview">
      <button class="btn-preview-action" (click)="recarregarPreview()">
        <i class="fas fa-sync-alt"></i> Atualizar
      </button>
      <button class="btn-preview-action" (click)="abrirEmNovaAba()">
        <i class="fas fa-external-link-alt"></i> Abrir Página
      </button>
    </div>
  </div>
</div>
